import { IconLayoutGrid, IconLayoutList } from "@tabler/icons-react";
import styles from "./ViewModeToggle.module.css";
// @ts-expect-error pure js
import { classnames } from "../../utils";
import type { ViewMode } from "./viewMode";

interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
  className?: string;
}

/** Bascule cartes / liste : deux boutons icône accolés, l'actif sur fond blanc. */
export default function ViewModeToggle({
  value,
  onChange,
  className,
}: ViewModeToggleProps) {
  return (
    <div
      className={classnames(styles.viewToggle, className)}
      role="group"
      aria-label="Affichage"
    >
      <button
        type="button"
        className={classnames(
          styles.toggleButton,
          value === "cards" && styles.toggleActive,
        )}
        onClick={() => onChange("cards")}
        aria-label="Vue en cartes"
        aria-pressed={value === "cards"}
        title="Vue en cartes"
      >
        <IconLayoutGrid size={18} />
      </button>
      <button
        type="button"
        className={classnames(
          styles.toggleButton,
          value === "list" && styles.toggleActive,
        )}
        onClick={() => onChange("list")}
        aria-label="Vue en liste"
        aria-pressed={value === "list"}
        title="Vue en liste"
      >
        <IconLayoutList size={18} />
      </button>
    </div>
  );
}
